import React from "react";
import CarouselHome from "../components/CarouselHome";
import Cards from "../components/CardsModule/Cards";

export default function Home() {
  return (
    <React.Fragment>
      <CarouselHome />
      <Cards />
    </React.Fragment>
  );
}
